import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import * as LayoutEvents from "../../../lib/LayoutEvents";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../SidePage.styles";
import { SidePageContext } from "../SidePageContext";
/**
 * Футер сайдпейджа.
 *
 * @visibleName SidePage.Footer
 */

export var SidePageFooter = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SidePageFooter, _React$Component);

  function SidePageFooter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.context = _this.context;
    _this.state = {
      fixed: false
    };
    _this.theme = void 0;
    _this.content = null;
    _this.wrapper = null;
    _this.layoutSub = null;

    _this.update = function () {
      _this.setProperStyles();
    };

    _this.refContent = function (node) {
      _this.content = node;
    };

    _this.refWrapper = function (node) {
      _this.wrapper = node;
    };

    _this.setProperStyles = function () {
      if (_this.wrapper && _this.content) {
        var wrapperRect = _this.wrapper.getBoundingClientRect();

        var contentRect = _this.content.getBoundingClientRect();

        var _fixed = wrapperRect.top > contentRect.top;

        _this.setState({
          fixed: _fixed
        });
      }
    };

    return _this;
  }

  var _proto = SidePageFooter.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$context$setHasF, _this$context, _this$context$setHasP, _this$context2;

    this.context.footerRef(this);
    this.update();
    this.layoutSub = LayoutEvents.addListener(this.update);
    (_this$context$setHasF = (_this$context = this.context).setHasFooter) == null ? void 0 : _this$context$setHasF.call(_this$context);
    (_this$context$setHasP = (_this$context2 = this.context).setHasPanel) == null ? void 0 : _this$context$setHasP.call(_this$context2, this.props.panel);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$context$setHasP2, _this$context3;

    this.props.panel !== prevProps.panel && ((_this$context$setHasP2 = (_this$context3 = this.context).setHasPanel) == null ? void 0 : _this$context$setHasP2.call(_this$context3, this.props.panel));
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$context$setHasF2, _this$context4, _this$context$setHasP3, _this$context5;

    this.context.footerRef(null);

    if (this.layoutSub) {
      this.layoutSub.remove();
    }

    (_this$context$setHasF2 = (_this$context4 = this.context).setHasFooter) == null ? void 0 : _this$context$setHasF2.call(_this$context4, false);
    (_this$context$setHasP3 = (_this$context5 = this.context).setHasPanel) == null ? void 0 : _this$context$setHasP3.call(_this$context5, false);
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this3 = this;

    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement("div", {
      style: {
        height: this.getContentHeight()
      },
      ref: this.refWrapper
    }, /*#__PURE__*/React.createElement(SidePageContext.Consumer, null, function (_ref) {
      var _cx;

      var getWidth = _ref.getWidth;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.footer(),
        style: {
          width: getWidth()
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(styles.footerContent(_this3.theme), (_cx = {}, _cx[styles.footerFixed(_this3.theme)] = _this3.state.fixed, _cx[styles.panel(_this3.theme)] = !!_this3.props.panel, _cx)),
        ref: _this3.refContent
      }, _this3.props.children));
    })));
  };

  _proto.getContentHeight = function getContentHeight() {
    if (!this.content) {
      return 'auto';
    }

    return this.content.getBoundingClientRect().height;
  };

  return SidePageFooter;
}(React.Component);
SidePageFooter.__KONTUR_REACT_UI__ = 'SidePageFooter';
SidePageFooter.contextType = SidePageContext;